import type { CampaignTabIndex } from '@common/components/CampaignSection';
import {
  clearCampaignTabFromUrl,
  getCampaignTabFromUrl,
  setCampaignTabInUrl,
} from '@campaign/utils/campaignTab';

import type { Store } from '@campaign/domain/store';
import * as reducers from '@campaign/domain/store/reducers';

/**
 * Applies campaign tab selection from the URL query string.
 *
 * @param store - the store
 * @returns void
 */
export function syncCampaignTabFromUrl(store: Store): void {
  if (!store.deref().loggedInUser.isLogged) {
    clearCampaignTabFromUrl();
    reducers.setSelectedCampaignTab(store, 0);
    return;
  }

  reducers.setSelectedCampaignTab(store, getCampaignTabFromUrl());
}

/**
 * Changes the selected campaign tab
 *
 * @param store - the store
 * @param selectedTab - the selected campaign tab
 * @returns void
 */
export function onChangeCampaignTab(
  store: Store,
  selectedTab: CampaignTabIndex
): void {
  if (selectedTab === store.deref().selectedCampaignTab) {
    return;
  }

  reducers.setSelectedCampaignTab(store, selectedTab);

  if (!store.deref().loggedInUser.isLogged) {
    return;
  }

  setCampaignTabInUrl(selectedTab);
}
